<template>
	<div>
		<template v-if="this.options?.name && this.options?.name?.length > 0">
			<label
					:for="this.options?.slug"
					class="radio-btn-unit__label"
					:class="{'required': this.options?.required}"
			>
				{{ this.options?.name }}
			</label>
		</template>

		<div
				:class="{
					'radio-btn-unit__container': true,
					'radio-btn-unit--error': this.options?.errorState ?? false,
					[this.options?.class ?? '']: true,
				}"
				:id="this.options?.slug"
				:required="this.options?.required ?? false"
				type="radio-btn"
		>
			<div v-for="(option, index) in this.options?.options" class="d-flex align-items-center">
				<input
						type="radio"
						class="radio-btn-unit__input"
						:name="this.options?.slug"
						:id="this.options?.slug+index"
						:value="option.value"
						:checked="this.modelValue === option.value"
						@input="this.valueChange($event.target.value)"
				>
				<label :for="this.options?.slug+index" class="radio-btn-unit__input-label">
					{{ option.name }}
				</label>
			</div>
		</div>

		<small
				v-show="this.options?.infoText && this.options?.infoText?.length > 0"
				:id="this.options?.slug+'_info'"
				class="mt-1 d-flex radio-btn-unit__label--secondary"
		>
			{{ this.options?.infoText }}
		</small>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {RadioButtonUnitOptions} from "./Interfaces/RadioButtonUnitOptions";

export default defineComponent({
	name: "RadioButtonUnit",
	emits: ['update:modelValue'],
	props: {
		options: {
			type: Object as PropType<RadioButtonUnitOptions>,
			required: true,
		},
		modelValue: {
			type: String,
			default: '',
			required: true
		},
	},
	methods: {
		valueChange(value: string): void {
			this.$emit('update:modelValue', value);
		},
	},
});
</script>

<style scoped>
</style>
